module.exports = __webpack_public_path__ + "static/media/user-tag.d2c1b516.svg";